module.exports = __webpack_public_path__ + "img/tab_customer.1b3ae24f.svg";